import { graphql } from '@teachino/shared-infrastructure';
import type { ResultOf } from 'gql.tada';

export const courseFragment = graphql(`
  fragment MaterialCourse on Course {
    id
    name
    shortName
    foregroundColor
    backgroundColor
  }
`);

export type MaterialCourse = ResultOf<typeof courseFragment>;
